var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHistoryViewTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 34
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#707070",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 6C11.4 6 6 11.4 6 18s5.4 12 12 12 12-5.4 12-12S24.6 6 18 6zm0 21.6c-5.3 0-9.6-4.3-9.6-9.6s4.3-9.6 9.6-9.6 9.6 4.3 9.6 9.6-4.3 9.6-9.6 9.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6 12h-1.8v7.2l6.3 3.8.9-1.5-5.4-3.2V12z"
}))));
export default SvgHistoryViewTool;